import { useState, useEffect } from "react";
import SectionCard from "../../Components/SectionCard";
import TextboxSet from "../../Components/TextboxSet";
import ImageUpload from "../../Components/ImageUpload";
import Switch from "react-switch";
import { XMarkIcon } from "@heroicons/react/24/solid";
import LocationSet from "../../Components/LocationSet";
import Button from "../../Components/Button";
import axios from "axios";
import { DELETE_EVENT_API } from "../../Constant/api";
import { useNavigate } from "react-router-dom";
import { EVENT_LIST } from "../../Router/path";
import { useToast } from "../../Components/Toast";
import Modal from "../../Components/Modal";
import { Warning2 } from "iconsax-react";
import Can from "../../Components/Can";

const EventInformation = ({ eventInfo, setEventInfo }) => {
  const [tab, setTab] = useState("General");
  // const [fileName, setFileName] = useState([]);
  const [deleteModal, setDeleteModal] = useState(false);
  const { toast } = useToast();

  const navigate = useNavigate();

  const handleOnChange = (e) => {
    const { name, value } = e.target;
    setEventInfo((prev) => ({ ...prev, [name]: value }));
  };

  const handleDeleteEvent = () => {
    try {
      axios
        .delete(DELETE_EVENT_API, {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("bearer_token")}`,
          },
          params: {
            eventId: sessionStorage.getItem("event_id"),
          },
        })
        .then((response) => {
          sessionStorage.removeItem("event_id");
          sessionStorage.removeItem("dietary");
          sessionStorage.removeItem("seat");
          navigate(EVENT_LIST);
          toast("Event deleted successfully", "success");
        })
        .catch((error) => {
          toast("Error deleting event", "error");
        });
    } catch (error) {
      toast("Error deleting event", "error");
    }
  };

  const handleImageChange = (value) => {
    if (!value) return;
    setEventInfo((prev) => ({
      ...prev,
      image: [...(Array.isArray(prev.image) ? prev.image : []), value],
    }));
  };

  const handleFloorplanChange = (value) => {
    if (!value) return;
    setEventInfo((prev) => ({
      ...prev,
      floor_plan: [
        ...(Array.isArray(prev.floor_plan) ? prev.floor_plan : []),
        value,
      ],
    }));
  };

  const handleRemoveFloorplanImage = (index) => {
    setEventInfo((prev) => ({
      ...prev,
      floor_plan: prev.floor_plan.filter((_, i) => i !== index),
    }));
  };

  const handleRemoveImage = (index) => {
    setEventInfo((prev) => ({
      ...prev,
      image: prev.image.filter((_, i) => i !== index),
    }));
  };

  const toggleModal = () => {
    setDeleteModal(!deleteModal);
  };

  // useEffect(() => {
  //   const imageName = eventInfo.image ?? [];
  //   const newFileNames = imageName.map((element) => element.split("/").pop());
  //   setFileName(newFileNames);
  // }, [eventInfo]);

  return (
    <div className="flex flex-col w-full gap-[24px]">
      {/* Event info section */}
      {deleteModal && (
        <Modal
          title="Delete Event"
          confirmation={handleDeleteEvent}
          toggleModal={toggleModal}
          submitLabel="Delete"
        >
          <div className="flex flex-col w-full items-center justify-center gap-[16px] py-[32px]">
            <Warning2 size="64" color="#ff0000" variant="Bold" />
            <p>Are you sure you want to delete this event?</p>
          </div>
        </Modal>
      )}
      <SectionCard title="Event Information">
        <div className="grid grid-cols-1 md:grid-cols-2 w-full gap-[12px] md:gap-[24px] p-[24px]">
          <TextboxSet
            type="text"
            name="name"
            value={eventInfo.name}
            label="Event Title"
            onChange={handleOnChange}
            required
          />
          <LocationSet
            onChange={handleOnChange}
            name="venue"
            value={eventInfo.venue}
            placeholder="Venue"
          />
          <TextboxSet
            type="date"
            name="date"
            value={eventInfo.date}
            label="Date"
            onChange={handleOnChange}
          />
          <TextboxSet
            type="time"
            name="time"
            value={eventInfo.time}
            label="Time"
            onChange={handleOnChange}
          />
          <div className="md:col-span-2">
            <TextboxSet
              type="textarea"
              name="description"
              value={eventInfo.description}
              label="Event Description"
              onChange={handleOnChange}
            />
          </div>
          <div className="md:col-span-2">
            <div className="flex flex-col gap-[12px] md:gap-[24px]">
              <div className="flex w-full gap-[16px] items-center">
                <Switch
                  checkedIcon={false}
                  uncheckedIcon={false}
                  offColor="#EFF0F2"
                  onColor="#5C4BF5"
                  width={48}
                  height={28}
                  checked={!!eventInfo.seat_management}
                  onChange={() => {
                    setEventInfo((prev) => ({
                      ...prev,
                      seat_management: !prev.seat_management,
                    }));
                  }}
                />
                <p>Seats Management</p>
              </div>
              <div className="flex w-full gap-[16px] items-center">
                <Switch
                  checkedIcon={false}
                  uncheckedIcon={false}
                  offColor="#EFF0F2"
                  onColor="#5C4BF5"
                  width={48}
                  height={28}
                  checked={!!eventInfo.dietary_management}
                  onChange={() => {
                    setEventInfo((prev) => ({
                      ...prev,
                      dietary_management: !prev.dietary_management,
                    }));
                  }}
                />
                <p>Special Dietray Management</p>
              </div>
            </div>
          </div>
        </div>
      </SectionCard>

      {/* Floorplan image upload section */}
      <SectionCard title="Floorplan Image">
        <div className="flex flex-col w-full p-[24px]">
          <ImageUpload handleChange={handleFloorplanChange} />
          {Array.isArray(eventInfo?.floor_plan) &&
            eventInfo.floor_plan.map((floorplan, index) => (
              <div
                key={index}
                className="relative flex flex-col w-full max-h-[200px] bg-black rounded-xl justify-center items-center mt-2"
              >
                <div className="absolute left-[20px] top-[8px] flex items-center gap-[18px]">
                  <XMarkIcon
                    className="size-[16px] h-fit text-white hover:cursor-pointer"
                    onClick={() => handleRemoveFloorplanImage(index)}
                  />
                  <p className="h-fit text-white font-normal">
                    {floorplan && typeof floorplan === "string"
                      ? decodeURIComponent(
                          floorplan.split("?")[0].split("/").pop(),
                        )
                      : "Unknown"}
                  </p>
                </div>
                <img
                  src={floorplan}
                  alt="floorplan-image"
                  className="h-[200px] object-contain"
                />
              </div>
            ))}
        </div>
      </SectionCard>

      {/* Event image upload section */}
      <SectionCard title="Event Image">
        <div className="flex flex-col w-full p-[24px]">
          <ImageUpload handleChange={handleImageChange} />
          {Array.isArray(eventInfo?.image) &&
            eventInfo.image.map((image, index) => (
              <div
                key={index}
                className="relative flex flex-col w-full max-h-[200px] bg-black rounded-xl justify-center items-center mt-2"
              >
                <div className="absolute left-[20px] top-[8px] flex items-center gap-[18px]">
                  <XMarkIcon
                    className="size-[16px] h-fit text-white hover:cursor-pointer"
                    onClick={() => handleRemoveImage(index)}
                  />
                  <p className="h-fit text-white font-normal">
                    {image && typeof image === "string"
                      ? decodeURIComponent(image.split("?")[0].split("/").pop())
                      : "Unknown"}
                  </p>
                </div>
                <img
                  src={image}
                  alt="event-image"
                  className="h-[200px] object-contain"
                />
              </div>
            ))}
        </div>
      </SectionCard>

      <Can permission="delete_event">
        <Button variant="error" className="w-fit" onClick={toggleModal}>
          Delete Event
        </Button>
      </Can>
    </div>
  );
};

export default EventInformation;
